import { THEME_MODE } from "../configs/constants"
import light from "../theme/light"
import dark from "../theme/dark"

export const getThemeObject = (themeMode, primary, secondaryLight = light.token.colorOdSecondary, secondaryDark = dark.token.colorOdSecondary) => {
    if (themeMode === THEME_MODE.LIGHT) {
        return {
            ...light,
            token: {
                ...light.token,
                "colorPrimary": primary || light.token.colorPrimary,
                "colorOdSecondary": secondaryLight
            },
        }
    }
    return {
        ...dark,
        token: {
            ...dark.token,
            "colorPrimary": primary || dark.token.colorPrimary,
            "colorOdSecondary": secondaryDark
        },
    }
}